"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Assert whether the given object is empty. It is considered empty if it has no
 * keys.
 *
 * @Param {object} obj = The object of which to assert if it is empty.
 *
 * @Example
 *
 *     isEmpty({})
 *     //=> true
 *
 *     isEmpty({ food: 'pizza' })
 *     //=> false
 *
 *     isEmpty({ food: undefined })
 *     //=> false
 */
function isEmpty(obj) {
    return Object.keys(obj).length < 1;
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=is-empty.js.map